(function (angular) {
    var STATE_NAME = 'app.account';

    angular.module('mobilezuz').config(['$stateProvider', '$urlRouterProvider', 'PAGE_ACCESS', function ($stateProvider, $urlRouterProvider, PAGE_ACCESS) {
        $stateProvider.state(STATE_NAME, {
            url: '/account?addressDetails',
            data: {
                stateAccess: PAGE_ACCESS.LOGGED_IN,
                bodyClass: 'account',
                metaTags: {
                    title: 'Account'
                }
            },
            views: {
                '@': {
                    templateUrl: 'views/account.html',
                    controller: 'AccountCtrl as accountCtrl',
                    resolve: {
                        userData: ['User', function (User) {
                            return User.getUserSettings();
                        }],
                        zipCodeLimitLength:['Config', function (config) {
                            var _US_ZIP_CODE_LENGTH = 5;
                            return config.retailer.currencyCode === 'USD' ? _US_ZIP_CODE_LENGTH : undefined;
                        }],
                        AddressFormService: ['AddressFormService', function(AddressFormService) {
                            return AddressFormService.initAddressFormService();
                        }],
                    }
                }
            }
        });
        $urlRouterProvider.when('/user-edit', '/account');
    }]).controller('AccountCtrl', [
        '$scope', '$rootScope', '$q', '$sce', '$state', '$filter', 'mDesign', 'Config', 'User', 'Api', 'Retailer',
        'SeniorCitizenVerificationDialog', 'Util', 'PaymentsService', 'userData', 'ChooseAreaDialog',
        'CREDIT_CARD_MODES', 'SP_SERVICES', 'SP_PAYMENTS', 'CITY_TYPES', 'PHONE_TYPES', 'ORGANIZATION_TYPES', 'AccountDeletionDialogSrv', '$timeout',
        'GOOGLE_AUTO_COMPLETE_TYPES', 'spGoogleMapsUtil', 'AddressFormService',
        'FILTER_ADDRESS_MODE', 'AddressService', 'GOOGLE_MAP_ADDRESS_TYPES', 'GMap', '$window', 'zipCodeLimitLength',
        function ($scope, $rootScope, $q, $sce, $state, $filter, mDesign, Config, User, Api, Retailer,
            SeniorCitizenVerificationDialog, Util, PaymentsService, userData, ChooseAreaDialog,
            CREDIT_CARD_MODES, SP_SERVICES, SP_PAYMENTS, CITY_TYPES, PHONE_TYPES, ORGANIZATION_TYPES, AccountDeletionDialogSrv, $timeout,
            GOOGLE_AUTO_COMPLETE_TYPES, spGoogleMapsUtil, AddressFormService,
            FILTER_ADDRESS_MODE, AddressService, GOOGLE_MAP_ADDRESS_TYPES, GMap, $window, zipCodeLimitLength
        ) {
            var accountCtrl = this,
                _translate = $filter('translate'),
                userLoginData = User.getUserLoginData(),
                _listeners = [],
                _originUserAddress;
            var _ADDRESS_TYPE_MAP = {
                city: 'city',
                text1: 'address',
                street: 'address',
                zipCode: 'zipCode'
            };
            var _wasText1HouseNumberShown = false;
            var _houseNumberRegExp = new RegExp(/^[0-9]+$/);

            accountCtrl.isRunAddressAutoComplete = true;

            _listeners.push(function () {
                accountCtrl.userAdress = _originUserAddress;
                accountCtrl.user.addresses[0] = accountCtrl.userAdress;
                _originUserAddress = angular.copy(_originUserAddress);
            });

            $rootScope.title = 'Account';

            accountCtrl.user = userData;
            _setUserPoints();
            accountCtrl.zipCodeLimitLength = zipCodeLimitLength;
            accountCtrl.isSeniorCitizen = userData.isSeniorCitizen;
            accountCtrl.title = 'Account';
            accountCtrl.isValidFloor = true;
            accountCtrl.userAdress = {};
            accountCtrl.customValidatedPhoneNumbers = {};
            accountCtrl.userAdressForm = {};
            accountCtrl.backupAddress = {};
            accountCtrl.dropPinDisableFields = AddressFormService.getDropPinDisableFields();
            accountCtrl.changePass = {
                email: userLoginData.email
            };
            accountCtrl.userSettings = {
                email: userLoginData.email,
                friendlyName: ''
            };
            accountCtrl.isExternalRegistration = userData.isExternalRegistration;
            accountCtrl.updateUserIframeURL = Config.retailer.externalLoginSettings && Config.retailer.externalLoginSettings.isActive ? $sce.trustAsResourceUrl(Config.retailer.externalLoginSettings.updateUserIframeURL) : '';
            accountCtrl.genderEnum = { male: 1, female: 2, prefer_not_to_say: 3 };
            accountCtrl.logout = User.logout;
            accountCtrl.disableAddCardButton = accountCtrl.user.organization && accountCtrl.user.organization.id && accountCtrl.user.organization.organizationType !== ORGANIZATION_TYPES.NO_OBLIGO;
            accountCtrl.compiledUserAddress = Util.compiledUserAddress();
            // user.getUserSettings(true).then(function (userSettings) {
            if (accountCtrl.user.gender !== null) {
                accountCtrl.userSettings.gender = accountCtrl.user.gender.toString();
            }
            var phones = {
                1: { phoneNumber: '', typeVal: PHONE_TYPES.HOME },
                2: { phoneNumber: '', typeVal: PHONE_TYPES.WORK },
                3: { phoneNumber: '', typeVal: PHONE_TYPES.MOBILE },
                4: { phoneNumber: '', typeVal: PHONE_TYPES.VERIFY }
            };
            angular.forEach(accountCtrl.user.phones, function (phone) {
                phones[phone.typeVal] = phone;
                compileCustomValidatedPhone(phone)
            });

            accountCtrl.userSettings.phones = phones;
            //(userSettings.dateOfBirth)?  userSettings.dateOfBirth = new Date(userSettings.dateOfBirth) : new Date(1990, 1, 1);
            //_.extend(accountCtrl.userSettings, userSettings);
            accountCtrl.userSettings.dateOfBirth = new Date(accountCtrl.user.dateOfBirth);
            accountCtrl.userAdress = accountCtrl.user.addresses[0];
            AddressFormService.cleanAddressDataBaseOnRetailerConfig(accountCtrl.userAdress, $rootScope.config.language.id);

            // Backup address
            angular.extend(accountCtrl.backupAddress, accountCtrl.userAdress);

            _originUserAddress = angular.copy(accountCtrl.userAdress);
            accountCtrl.userSettings.friendlyName = accountCtrl.user.firstName + ' ' + accountCtrl.user.lastName;
            accountCtrl.userSettings.firstName = accountCtrl.user.firstName;
            accountCtrl.userSettings.lastName = accountCtrl.user.lastName;
            accountCtrl.userSettings.allowSendPromotions = accountCtrl.user.allowSendPromotions;
            accountCtrl.userSettings.allowSendSmsPromotions = accountCtrl.user.allowSendSmsPromotions;
            accountCtrl.userSettings.allowSendEmailPromotions = accountCtrl.user.allowSendEmailPromotions;
            accountCtrl.customPhoneRegExp = new RegExp(/^\(?\+?(\d[0-9\)\(-]*)$/);
            accountCtrl.phoneRegExp = new RegExp(/^\(?\+?(\d[\s,\-,(,),,,]*){7,15}$/);
            accountCtrl.customPhoneValidation = Config.retailer.customPhoneValidation && Config.retailer.customPhoneValidation.isActive;
            accountCtrl.phoneValidationSubmitted = false;
            accountCtrl.homePhone = accountCtrl.userSettings.phones[1].customPhoneNumber;
            accountCtrl.workPhone = accountCtrl.userSettings.phones[2].customPhoneNumber;
            accountCtrl.mobilePhone = accountCtrl.userSettings.phones[3].customPhoneNumber;
            accountCtrl.editPhonesMode = {};
            accountCtrl.countryNames = Util.getCountryAutocompleteOptions();

            // });
            if (accountCtrl.customPhoneValidation) {
                accountCtrl.phoneRegExp = new RegExp(/^\(?\+?(\d[0-9]*)$/);

                angular.forEach(accountCtrl.userSettings.phones, function (phone) {
                    if (Config.retailer.customPhoneValidation.areaCodes && Config.retailer.customPhoneValidation.areaCodes.length === 1) {
                        phone.areaCode = Config.retailer.customPhoneValidation.areaCodes[0]
                    }

                    if (Config.retailer.customPhoneValidation.countryCodes && Config.retailer.customPhoneValidation.countryCodes.length === 1) {
                        phone.countryCode = Config.retailer.customPhoneValidation.countryCodes[0]
                    }
                });
                accountCtrl.editPhonesMode = {
                    1: !accountCtrl.userSettings.phones[1].phoneNumber,
                    2: !accountCtrl.userSettings.phones[2].phoneNumber,
                    3: !accountCtrl.userSettings.phones[3].phoneNumber,
                }
            }

            accountCtrl.isUseNewAddressesFeature = AddressFormService.isUseNewAddressesFeature;
            accountCtrl.isGMapWithZipCodeProvider = Config.retailer.settings.autocompleteAddressField && Config.retailer.settings.activeZipProvider && Config.retailer.settings.activeZipProvider.name === 'Get Address'

            accountCtrl.getCityAutoCompleteOptions = getCityAutoCompleteOptions;
            accountCtrl.getStreetAutoCompleteOptions = getStreetAutoCompleteOptions;
            accountCtrl.onCityChosen = onCityChosen;
            accountCtrl.addCreditCard = addCreditCard;
            accountCtrl.isSeniorCitizenChange = isSeniorCitizenChange;
            accountCtrl.toggleForm = toggleForm;
            accountCtrl.goToCouponsPage = goToCouponsPage;
            accountCtrl.goToContactUsPage = goToContactUsPage;
            accountCtrl.isPassEquals = isPassEquals;
            accountCtrl.changePassword = changePassword;
            accountCtrl.phoneNumber = phoneNumber;
            accountCtrl.saveMembershipInfo = saveMembershipInfo;
            accountCtrl.sendTicket = sendTicket;
            accountCtrl.createNewTicket = createNewTicket;
            accountCtrl.toggleTicket = toggleTicket;
            accountCtrl.removeCard = removeCard;
            accountCtrl.removePaypalAccount = removePaypalAccount;
            accountCtrl.validateCountryCode = validateCountryCode;
            accountCtrl.validateAreaCode = validateAreaCode;
            accountCtrl.phoneEditMode = phoneEditMode;
            accountCtrl.initAccountDeletionProcess = initAccountDeletionProcess;
            accountCtrl.checkForAutocompleteAddress = checkForAutocompleteAddress;
            accountCtrl.openAutocompleteAddress = openAutocompleteAddress;
            accountCtrl.filterCountryNames = filterCountryNames;

            accountCtrl.getCityAutoCompleteOptionsV2 = getCityAutoCompleteOptionsV2;
            accountCtrl.onCityChosenV2 = onCityChosenV2;
            accountCtrl.onCityBlurV2 = onCityBlurV2;
            accountCtrl.onAddressBlurV2 = onAddressBlurV2;
            accountCtrl.onHouseNumberBlurV2 = onHouseNumberBlurV2;
            accountCtrl.onAddressInputKeydownV2 = onAddressInputKeydownV2;
            accountCtrl.isDisableAddressFieldV2 = isDisableAddressFieldV2;
            accountCtrl.getAddressAutoCompleteOptionsV2 = getAddressAutoCompleteOptionsV2;
            accountCtrl.openGoogleMapDialogV2 = openGoogleMapDialogV2;
            accountCtrl.onAddressChosenV2 = onAddressChosenV2;
            accountCtrl.editDropPinAddressField = editDropPinAddressField;
            accountCtrl.onDropPinAddressFieldBlur = _disableAllDropPinFields;
            accountCtrl.editDropPinAddressField = editDropPinAddressField;
            accountCtrl.isDropPinRequiredStreetAndHouseNumber = isDropPinRequiredStreetAndHouseNumber;
            accountCtrl.isShowAddressField = isShowAddressField;
            accountCtrl.cancelPinnedAddress = cancelPinnedAddress;
            accountCtrl.onZipCodeBlur = onZipCodeBlur;
            accountCtrl.saveAddress = saveAddress;
            accountCtrl.saveMembershipInfoV2 = saveMembershipInfoV2;
            accountCtrl.setUserAdressFormRef = setUserAdressFormRef;
            accountCtrl.getFieldErrorMsg = AddressFormService.getFieldErrorMsg;
            accountCtrl.getAddressFieldLabel = getAddressFieldLabel;
            accountCtrl.getAddressFormFieldSettings = getAddressFormFieldSettings;
            accountCtrl.getDropPinClarifyMessage = getDropPinClarifyMessage;
            accountCtrl.currentLanguageId = Config.language.id;

            Retailer.getRetailerSettings().then(function (response) {
                accountCtrl.deliveryAreaMethod = response.deliveryAreaMethod;
                if (response.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE || response.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.CITY) {
                    getCityAutoCompleteOptions().then(function (citiesList) {
                        if (citiesList) {
                            var matching = false;
                            for (var i = 0; i < citiesList.length; i++) {
                                if (citiesList[i] === accountCtrl.userAdress.city) {
                                    matching = true;
                                }
                            }
                            if (!matching) delete accountCtrl.userAdress.city;
                        }
                    });
                }

                var settings = Util.getBranchSettings(response);
                var hasCreditCardOption = (response.checkoutPaymentMethods || []).some(function (paymentMethod) {
                    return paymentMethod.name === SP_PAYMENTS.PAYMENT_METHODS.NAMES.CREDIT_CARD;
                });

                accountCtrl.withSavedCreditCards = hasCreditCardOption && settings.creditCardMode == CREDIT_CARD_MODES.REMEMBER_CARDS;
                accountCtrl.enableFloorApartment = response.enableFloorApartment;

                accountCtrl.isSeniorCitizenActive = response.isSeniorCitizenActive;
                _checkAddressFields();
                filterCountryNames();

                var isEnable = Config.retailer.settings.isAddressVerificationEnabled === 'true';
                var isUseGoogleMapApi = [SP_SERVICES.DELIVERY_AREA_METHODS.POLYGON, SP_SERVICES.DELIVERY_AREA_METHODS.GOOGLE_MAPS].includes(accountCtrl.deliveryAreaMethod);
                accountCtrl.isAddressVerificationEnabled = isEnable && isUseGoogleMapApi;
                accountCtrl.isUseGMapDeliveryMethod = isUseGoogleMapApi;

                if (
                    // is in pilot updates
                    AddressFormService.isUseNewAddressesFeature &&
                    // is GOOGLE_MAPS / POLYGON
                    accountCtrl.isUseGMapDeliveryMethod
                ) {
                    // GOOGLE_MAPS / POLYGON with Zip-code provider will use old form => don't need to load form settings
                    if (accountCtrl.isGMapWithZipCodeProvider) {
                        accountCtrl.streetIsRequire = Config.retailer.settings.addressPrecision !== DELIVERY_AREA_METHODS_PRECISION.CITY_STREET_NOT_REQUIRED;
                        return;
                    }

                    accountCtrl.streetIsRequire = true
                    delete Config.retailer.settings.enableDefaultCountry

                    accountCtrl.isGoogleMapDropPinAllow = AddressFormService.isGoogleMapDropPinAllow;
                    accountCtrl.enableAddressFiltering = AddressFormService.enableAddressFiltering;
                    accountCtrl.isAddressFilteringCityMode = AddressFormService.isAddressFilteringCityMode;
                    accountCtrl.isAddressFilteringZipCodeMode = AddressFormService.isAddressFilteringZipCodeMode;

                    // pre-validate zipcode
                    onZipCodeBlur();
                    _getAddressFromMap();

                   _initAdvancedPromotionCheckbox();
                }

            });

            _getUserTickets();
            _initCreditCards();
            _initPaypalAccounts();

            setTimeout(function () {
                if (Config.retailer.externalLoginSettings && Config.retailer.externalLoginSettings.isActive) {
                    disableFormElements('user-edit');
                }
            }, 100);


            function _initAdvancedPromotionCheckbox() {
                accountCtrl.advancedPromotionCheckbox = Util.getAdvancedPromotionCheckboxConfig();
                accountCtrl.shouldShowAdvancedPromotionCheckbox = accountCtrl.advancedPromotionCheckbox && accountCtrl.advancedPromotionCheckbox.isActive;
                if (accountCtrl.shouldShowAdvancedPromotionCheckbox && accountCtrl.advancedPromotionCheckbox.checkboxList) {
                    
                    for (var key in accountCtrl.advancedPromotionCheckbox.checkboxList) {
                        var checkbox = accountCtrl.advancedPromotionCheckbox.checkboxList[key];
                        checkbox.currentLanguageId = Config.language.id
                    }

                }
            }

            $scope.$watch(function() {
				return Config.language;
			}, function(newLanguage, oldLanguage) {
                if(newLanguage && newLanguage.id) {
                    accountCtrl.currentLanguageId = newLanguage.id;
                }
			});
            
            function _getUserTickets(getLastData) {
                User.getUserTickets(getLastData).then(function (tickets) {
                    angular.forEach(tickets, function (ticket) {
                        ticket.normalizedDate = normalizeTime(ticket.createdDate);
                        angular.forEach(ticket.comments, function (comment) {
                            comment.normalizedDate = normalizeTime(comment.dbDate + 'Z');
                        });
                    });

                    accountCtrl.tickets = tickets;
                    accountCtrl.noTickets = tickets.length === 0;
                });
            }

            function normalizeTime(time) {
                var date = new Date(time);
                var timeOffsetInMS = $rootScope.config.retailer.timeZoneOffset * 60000;
                var localTimeOffset = new Date().getTimezoneOffset() * 60000;
                return new Date(date.setTime((date.getTime() + timeOffsetInMS) - localTimeOffset));
            }

            /*
             Fields show/hide animation
             */
            var _opened;
            function toggleForm($event) {
                $event.preventDefault();
                $event.stopPropagation();

                var $element = angular.element($event.delegateTarget || $event.currentTarget),
                    $form = $element.next();

                if (_opened) {
                    _opened.css('display', 'none');

                    _opened = $form[0] !== _opened[0] ? $form.css('display', 'block') : null;
                } else {
                    _opened = $form.css('display', 'block');
                }
            }

            function disableFormElements(formId) {
                var form = document.getElementById(formId);
                if (form) {
                    var elements = form.getElementsByTagName('input');
                    for (var i = 0; i < elements.length; i++) {
                        elements[i].disabled = true;
                        elements[i].style.opacity = "0.5";
                    }
                }
            }

            function goToCouponsPage($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $state.go('app.myCoupons');
            }

            function goToContactUsPage($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $state.go('app.retailer.contactUs');
            }

            function isPassEquals() {
                if (accountCtrl.changePass.newPass && accountCtrl.changePass.newPassConfirm) {
                    return accountCtrl.changePass.newPass == accountCtrl.changePass.newPassConfirm;
                }
            }

            function _successMsg() {
                mDesign.alert(_translate('Settings was successfully changed!'));
                //accountCtrl.userAdressForm.$setPristine();
                // accountCtrl.membershipForm.$setPristine();
                User.getUserSettings(true).then(function (userSettings) {
                    accountCtrl.user = userSettings;
                    _checkAddressFields();
                    angular.forEach(userSettings.phones, function (phone) {
                        _setPhoneInputs(phone.typeVal);
                        accountCtrl.editPhonesMode[phone.typeVal] = false;
                        compileCustomValidatedPhone(phone);
                    });
                });
            }

            function changePassword() {
                var data = {
                    token: User.getUserLoginData().token,
                    newPassword: accountCtrl.changePass.newPass,
                    oldPassword: accountCtrl.changePass.pass
                };

                Api.request({
                    method: 'POST',
                    url: 'retailers/:rid/users/_changePassword',
                    data: data
                }).then(function (respond) {
                    if (respond.success) {
                        _successMsg();
                    }
                });
            }

            function phoneNumber(index) {
                var placeholders = ['Home phone', 'Other phone', 'Cell phone'];

                return placeholders[index - 1];
            }

            function saveMembershipInfo() {
                accountCtrl.userAdress.entry = _getEntryValue(accountCtrl.userAdress.entry)
                var phonesCopy = angular.copy(accountCtrl.userSettings.phones)
                if (accountCtrl.customPhoneValidation) {
                    accountCtrl.editPhonesMode = {
                        1: !accountCtrl.userSettings.phones[1].phoneNumber,
                        2: !accountCtrl.userSettings.phones[2].phoneNumber,
                        3: !accountCtrl.userSettings.phones[3].phoneNumber,
                    }
                    accountCtrl.homePhone = phonesCopy[1] ? phonesCopy[1].customPhoneNumber : '';
                    accountCtrl.workPhone = phonesCopy[2] ? phonesCopy[2].customPhoneNumber : '';
                    accountCtrl.mobilePhone = phonesCopy[3] ? phonesCopy[3].customPhoneNumber : '';
                    var phoneCopyArr = Object.values(phonesCopy) || [];

                    phoneCopyArr.forEach(function (phone) {
                        if (accountCtrl.userSettings.phones && accountCtrl.userSettings.phones[phone.typeVal] && (accountCtrl.userSettings.phones[phone.typeVal].phoneNumber || accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber)) {
                            accountCtrl.userSettings.phones[phone.typeVal].phoneNumber = accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber ? accountCtrl.userSettings.phones[phone.typeVal].areaCode + accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber : '';
                            accountCtrl.userSettings.phones[phone.typeVal].customValidated = (accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber && accountCtrl.customPhoneValidation);
                            compileCustomValidatedPhone(accountCtrl.userSettings.phones[phone.typeVal]);
                        }
                        _setPhoneInputs(phone.typeVal);
                    });
                    accountCtrl.userSettings.phones = phones;
                }

                if (_shouldClearAddressData()) {
                    var clearingFields = {
                        externalPlaceId: null,
                        lat: null,
                        lng: null
                    };

                    angular.extend(accountCtrl.userAdress, clearingFields);
                    angular.extend(accountCtrl.backupAddress, accountCtrl.userAdress);
                }

                var _userAddress = AddressFormService.getCheckoutAddress(accountCtrl.userAdress);

                if (accountCtrl.userSettings.password !== accountCtrl.userSettings.confirmPassword) {
                    return mDesign.alert('The passwords must match');
                }

                var sendingData = {
                    firstName: accountCtrl.userSettings.firstName,
                    lastName: accountCtrl.userSettings.lastName,
                    birthDate: accountCtrl.userSettings.dateOfBirth,
                    allowSendPromotions: accountCtrl.userSettings.allowSendPromotions,
                    allowSendSmsPromotions: accountCtrl.userSettings.allowSendSmsPromotions,
                    allowSendEmailPromotions: accountCtrl.userSettings.allowSendEmailPromotions,
                    gender: parseFloat(accountCtrl.userSettings.gender),
                    phones: accountCtrl.userSettings.phones,
                    addresses: [_userAddress]
                };

                if (accountCtrl.userSettings.password) {
                    sendingData.password = accountCtrl.userSettings.password;
                }

                // can only unselect is senior citizen through here
                if (!accountCtrl.isSeniorCitizen && accountCtrl.user.isSeniorCitizen) {
                    sendingData.isSeniorCitizen = false;
                }
                accountCtrl.phoneValidationSubmitted = true;
                Api.request({
                    method: 'PATCH',
                    url: 'retailers/:rid/users/:uid',
                    data: sendingData
                }).then(function () {
                    _originUserAddress = angular.copy(_userAddress);
                    _successMsg();
                }).catch(function () {
                    User.getUserSettings(true).then(function (userSettings) {
                        accountCtrl.user = userSettings;
                        angular.forEach(userSettings.phones, function (phone) {
                            _setPhoneInputs(phone.typeVal);
                            accountCtrl.editPhonesMode[phone.typeVal] = false;
                            compileCustomValidatedPhone(phone);
                        });
                    });
                });
            }

            function _shouldClearAddressData() {
                var fieldsToCheck = ['city', 'text1', 'zipCode', 'street', 'houseNumber'];
                var currentAddress = accountCtrl.userAdress;
                var backupAddress = accountCtrl.backupAddress;
                
                for(var i = 0; i < fieldsToCheck.length; i++) {
                    var field = fieldsToCheck[i];
                    if(backupAddress[field] === null && currentAddress[field] === null) {
                        continue;
                    }

                    if(AddressFormService.isLocationChanged(field, backupAddress, currentAddress)) {
                        return true;
                    }
                }
                
                return false;
            }

            function phoneEditMode(phoneType, editMode) {
                if (accountCtrl.customPhoneValidation) {
                    if (accountCtrl.editPhonesMode[phoneType] && editMode) {
                        return;
                    }
                    accountCtrl.customValidatedPhoneNumbers[phoneType] = '';
                    accountCtrl.editPhonesMode[phoneType] = editMode;
                    if (editMode) {
                        accountCtrl.userSettings.phones[phoneType].customPhoneNumber = accountCtrl.userSettings.phones[phoneType].customPhoneNumber || '';
                        setTimeout(function () {
                            var newInputField = document.getElementById('phone-input-' + phoneType);
                            if (newInputField) {
                                newInputField.focus()
                            }
                        }, 0);
                        angular.forEach(accountCtrl.user.phones, function (phone) {
                            if (phone.typeVal !== phoneType) {
                                _setPhoneInputs(phone.typeVal);
                                accountCtrl.editPhonesMode[phone.typeVal] = false;
                                compileCustomValidatedPhone(phone);
                            }
                        })
                    } else {
                        _setPhoneInputs(phoneType);
                        compileCustomValidatedPhone(accountCtrl.userSettings.phones[phoneType])
                    }
                }
            }

            function compileCustomValidatedPhone(phone) {
                phone.customValidated = (phone.customValidated && phone.customPhoneNumber)
                if (phone.customValidated) {
                    if (phone.phoneNumber && phone.customValidated) {
                        accountCtrl.customValidatedPhoneNumbers[phone.typeVal] = [
                            phone.countryCode ? phone.countryCode.toString() : '',
                            phone.areaCode ? phone.areaCode.toString() : '',
                            phone.customPhoneNumber ? phone.customPhoneNumber.toString() : ''
                        ].join('');
                    } else if (phone.phoneNumber && phone.customPhoneNumber !== '' && !phone.customValidated) {
                        accountCtrl.customValidatedPhoneNumbers[phone.typeVal] = phone.phoneNumber
                    } else {
                        accountCtrl.customValidatedPhoneNumbers[phone.typeVal] = '';
                    }

                } else {
                    accountCtrl.customValidatedPhoneNumbers[phone.typeVal] = phone.phoneNumber;
                }
            }

            function _setPhoneInputs(phoneType) {
                switch (phoneType) {
                    case PHONE_TYPES.HOME: {
                        accountCtrl.userSettings.phones[1].customPhoneNumber = accountCtrl.homePhone;
                        break;
                    }
                    case PHONE_TYPES.WORK: {
                        accountCtrl.userSettings.phones[2].customPhoneNumber = accountCtrl.workPhone;
                        break;
                    }
                    case PHONE_TYPES.MOBILE: {
                        accountCtrl.userSettings.phones[3].customPhoneNumber = accountCtrl.mobilePhone;
                        break;
                    }
                    default:
                        return;
                }
            }

            function validateCountryCode(countryCode, phoneNumber) {
                if (phoneNumber && accountCtrl.phoneValidationSubmitted) {
                    return Config.retailer.customPhoneValidation.countryCodes.some(function (code) {
                        return code == countryCode;
                    });
                }
                return true;
            }


            function validateAreaCode(areaCode, phoneNumber) {
                if (phoneNumber && accountCtrl.phoneValidationSubmitted) {
                    return Config.retailer.customPhoneValidation.areaCodes.some(function (code) {
                        return code == areaCode;
                    });
                }
                return true;
            }

            function getCityAutoCompleteOptions() {
                if (!accountCtrl.userAdress.city) {
                    return $q.resolve();
                }

                return Api.request({
                    method: 'GET',
                    url: '/v2/addresses/cities',
                    params: {
                        term: accountCtrl.userAdress.city,
                        size: 5
                    }
                }).then(function (data) {
                    accountCtrl.citiesObject = {};
                    return data.cities.map(function (city) {
                        accountCtrl.citiesObject[city.name] = city;
                        return city.name;
                    });
                });
            }

            function onCityChosen() {
                accountCtrl.streetIsRequire = (accountCtrl.citiesObject[accountCtrl.userAdress.city] && accountCtrl.citiesObject[accountCtrl.userAdress.city].type === CITY_TYPES.MULTIPLE_ZIP_CODES);
            }

            //set "None" value as null
            function _getEntryValue(entry) {
                if (entry === _translate($rootScope.HOUSE_ENTRIES[0])) {
                    return null;
                }
                return entry;
            }

            function getStreetAutoCompleteOptions() {
                if (!accountCtrl.userAdress.street) return;
                var cityId = accountCtrl.citiesObject[accountCtrl.userAdress.city] && accountCtrl.citiesObject[accountCtrl.userAdress.city].id;

                if (!cityId) {
                    return;
                }

                return Api.request({
                    method: 'GET',
                    url: '/v2/addresses/streets',
                    params: {
                        term: accountCtrl.userAdress.street,
                        cityId: cityId,
                        size: 4
                    }
                }).then(function (data) {
                    return data.streets.map(function (street) {
                        return street.name;
                    });
                });
            }

            /* Contact Us*/
            function sendTicket() {

                if (angular.isUndefined($rootScope.config.getBranchArea())) {
                    return ChooseAreaDialog.show(false);
                }

                accountCtrl.details = {};
                accountCtrl.details.branchId = Config.branch.id;
                accountCtrl.details.userId = accountCtrl.user.id;
                accountCtrl.details.name = accountCtrl.user.firstName + ' ' + accountCtrl.user.lastName;
                accountCtrl.details.email = accountCtrl.user.email;
                accountCtrl.details.phone = accountCtrl.user.phones && accountCtrl.user.phones.length ? accountCtrl.user.phones[0].phoneNumber : '';
                accountCtrl.details.message = accountCtrl.contactUs;

                if (accountCtrl.details.message) {
                    Api.request({
                        method: 'POST',
                        url: '/retailers/:rid/contactUs',
                        data: accountCtrl.details
                    }).then(function () {
                        //$scope.isSent = true;
                        $rootScope.$emit('contactUs', accountCtrl.details.email, accountCtrl.details.name);
                        accountCtrl.contactUs = '';
                        _getUserTickets(true);

                    }).catch(function (res) {
                        // Util.setServerErrorToForm(form, formElement, res);
                    });
                }
                else {
                    return mDesign.dialog({
                        focusOnOpen: false,
                        clickOutsideToClose: true,
                        template: '<md-dialog><md-dialog-content>Please add new request</md-dialog-content><md-dialog-actions><md-button ng-click="hide()" aria-label="Close"  ng-bind="::\'Close\' | translate"></md-button></md-dialog-actions></md-dialog>',
                        controller: ['$scope', function ($scope) {
                            $scope.hide = hide;
                            function hide() {
                                mDesign.hide();
                            }
                        }]
                    })
                }
            }

            /* Tickets */
            function createNewTicket(selectedTicket) {
                mDesign.dialog({
                    focusOnOpen: false,
                    clickOutsideToClose: false,
                    templateUrl: 'views/templates/add-ticket.html',
                    controller: ['$scope', function ($scope) {
                        $scope.createUserTicketComment = createUserTicketComment;
                        $scope.selectedTicket = selectedTicket;
                        $scope.cancel = hide;
                        $scope.attachments = [];

                        function hide() {
                            mDesign.hide();
                        }

                        function createUserTicketComment() {
                            mDesign.hide();

                            if (!$scope.userTicketComment.comment) return;
                            $scope.userTicketComment.ticketId = $scope.selectedTicket.id;

                            User.uploadTicketAttachment($scope.userTicketComment.attachment).then(function (data) {
                                if (data) {
                                    $scope.userTicketComment.attachments = [data.url.fullUrl];
                                }
                                return User.createUserTicketComment($scope.userTicketComment);
                            }).then(function (data) {
                                if (!data.success) {
                                    return;
                                }

                                $scope.userTicketComment.createdDate = new Date();
                                $scope.userTicketComment.commentById = accountCtrl.user.id;
                                $scope.userTicketComment.local = true;
                                $scope.userTicketComment.normalizedDate = $scope.userTicketComment.createdDate;
                                $scope.selectedTicket.comments.push($scope.userTicketComment);
                                $scope.userTicketComment = {};
                                if ($scope.attachments.length > 0) {
                                    $scope.selectedTicket.attachments = $scope.attachments;
                                    $scope.attachments = [];
                                }
                            });
                        }
                    }]
                });
            }

            function toggleTicket(ticket) {
                angular.forEach(accountCtrl.tickets, function (ticketItem) {
                    if (ticket == ticketItem) return;
                    ticketItem.ticketInfo = false;
                });

                ticket.ticketInfo = !ticket.ticketInfo;
            }

            /* Credit Card */
            function _initCreditCards() {
                accountCtrl.creditCards = accountCtrl.user.creditCards || [];
                var defaultCard = accountCtrl.user.creditCards ? angular.filterCollection(accountCtrl.user.creditCards, function (x) {
                    return x.isDefault;
                }) : null;
                accountCtrl.creditCard = defaultCard && defaultCard.length ? defaultCard[0] : (accountCtrl.user.creditCards && accountCtrl.user.creditCards.length ? accountCtrl.user.creditCards[0] : null);
            }

            /* PayPal */
            function _initPaypalAccounts() {
                accountCtrl.paypalAccounts = accountCtrl.user.paypalAccounts || [];
                var defaultPaypalAccount = accountCtrl.user.paypalAccounts ? angular.filterCollection(accountCtrl.user.paypalAccounts, function (x) {
                    return x.isDefault;
                }) : null;
                accountCtrl.paypalAccount = defaultPaypalAccount && defaultPaypalAccount.length ? defaultPaypalAccount[0]
                    : (accountCtrl.user.paypalAccount && accountCtrl.user.paypalAccount.length ? accountCtrl.user.paypalAccount[0] : null);
            }

            function removeCard(selectedCard) {
                return mDesign.dialog({
                    focusOnOpen: false,
                    clickOutsideToClose: false,
                    templateUrl: 'views/templates/remove-credit-card.html',
                    controller: ['$scope', function ($scope) {
                        $scope.selectedCard = selectedCard;
                        $scope.delete = deleteCardInfo;
                        $scope.cancel = cancel;

                        function cancel() {
                            mDesign.hide();
                        }

                        function deleteCardInfo() {
                            mDesign.hide();

                            return Api.request({
                                method: 'DELETE',
                                url: '/retailers/:rid/users/:uid/removecard',
                                data: {
                                    cardId: $scope.selectedCard.id
                                },
                                headers: {
                                    'content-type': 'application/json'
                                }
                            }).then(function () {
                                setTimeout(function () {
                                    User.getUserSettings(true)
                                        .then(function (data) {
                                            accountCtrl.user = data;
                                            _initCreditCards();
                                        })
                                }, 1000);
                                $scope.$applyAsync();
                            });
                        }
                    }]
                });
            }

            function addCreditCard() {
                if (Config.retailer.settings.useDeliveryAddressAsBilling && accountCtrl.compiledUserAddress) {
                    return mDesign.dialog({
                        templateUrl: 'views/templates/use-delivery-address-as-billing.html',
                        controller: ['$scope', function ($dialogScope) {
                            var dialogCtrl = this;
                            dialogCtrl.sendUserAddress = false;
                            var userAddress = accountCtrl.user.addresses && accountCtrl.user.addresses[0];
                            var userCountryName = userAddress && userAddress.country;
                            if (userCountryName) {
                                userAddress.countryCode = Util.getCountryCode(userCountryName);
                            }
                            dialogCtrl.compiledUserAddress = Util.compiledUserAddress(_originUserAddress);
                            dialogCtrl.cancel = cancel;
                            $dialogScope.continue = function () {
                                mDesign.hide();
                                return PaymentsService.addCreditCard({
                                    sendUserAddress: dialogCtrl.sendUserAddress,
                                    address: userAddress.text1 ? userAddress.text1 : userAddress.text2 ? userAddress.text2 : '',
                                    city: userAddress.city ? userAddress.city : '',
                                    country: userAddress.country ? userAddress.country : '',
                                    countryCode: userAddress.countryCode ? userAddress.countryCode : '',
                                }).then(function () {
                                    setTimeout(function () {
                                        User.getUserSettings(true)
                                            .then(function (data) {
                                                accountCtrl.user = data;
                                                _initCreditCards();
                                            })
                                    }, 1000);
                                });
                            };

                            function cancel() {
                                mDesign.hide();
                            }
                        }],
                        controllerAs: 'dialogCtrl',
                        styleClass: 'clear-cart-popup'
                    });
                } else {
                    return PaymentsService.addCreditCard().then(function () {
                        setTimeout(function () {
                            User.getUserSettings(true)
                                .then(function (data) {
                                    accountCtrl.user = data;
                                    _initCreditCards();
                                })
                        }, 1000);
                    });
                }
            }

            function removePaypalAccount(selected) {
                return mDesign.dialog({
                    focusOnOpen: false,
                    clickOutsideToClose: false,
                    templateUrl: 'views/templates/remove-paypal-account.html',
                    controller: ['$scope', function ($scope) {
                        $scope.selectedAccount = selected;
                        $scope.delete = deletePaypalAccount;
                        $scope.cancel = cancel;

                        function cancel() {
                            mDesign.hide();
                        }

                        function deletePaypalAccount() {
                            mDesign.hide();

                            return Api.request({
                                method: 'DELETE',
                                url: '/retailers/:rid/users/:uid/removepaypalaccount',
                                data: {
                                    accountId: $scope.selectedAccount.id
                                },
                                headers: {
                                    'content-type': 'application/json'
                                }
                            }).then(function () {
                                return User.getUserSettings(true);
                            }).then(function (data) {
                                accountCtrl.user = data;
                                _initPaypalAccounts();
                                $scope.$applyAsync();
                            });
                        }
                    }]
                });
            }

            function isSeniorCitizenChange() {
                if (!accountCtrl.isSeniorCitizen || accountCtrl.user.isSeniorCitizen) {
                    return;
                }

                return SeniorCitizenVerificationDialog.show().then(function () {
                    return User.getUserSettings();
                }).then(function (userData) {
                    accountCtrl.user = userData;
                    accountCtrl.isSeniorCitizen = userData.isSeniorCitizen;
                });
            }

            function initAccountDeletionProcess() {
                AccountDeletionDialogSrv.show();
            }

            function _checkAddressFields() {
                if (accountCtrl.user.addresses && accountCtrl.user.addresses.length) {
                    accountCtrl.user.hasAddressDetails = Util.checkAddressFields(accountCtrl.user.addresses[0]);
                }
            }

            function _setUserPoints() {
                if (accountCtrl.user && accountCtrl.user.loyaltyClubs && accountCtrl.user.loyaltyClubs.length > 0) {
                    var loyaltyClub = Util.findUserCashbackLoyaltyClub();
                    if (loyaltyClub) {
                        Util.getUserCashbackPoints(loyaltyClub.id).then(function (response) {
                            accountCtrl.user.points = (Number(accountCtrl.user.points) || 0) +
                                (Number(response.points) || 0);
                        });
                    }
                }
            }

            function checkForAutocompleteAddress(evt) {
                if ((evt.target.disabled || angular.element(evt.target).attr('disabled') === 'disabled' || evt.target.name === 'zip') &&
                    Config.retailer.settings.autocompleteAddressField) {
                    if (evt.target.name === 'zip') {
                        mDesign.alert(_translate('zipcode error'));
                    } else {
                        if (!Config.retailer.settings.activeZipProvider.isLockedAddress) {
                            mDesign.alert(_translate('not editable error'));
                        } else if (Config.retailer.settings.activeZipProvider.isLockedAddress) {
                            if (!accountCtrl.userAdress.city) {
                                mDesign.alert(_translate('not_editable_locked_empty error'));
                            } else {
                                mDesign.alert(_translate('not_editable_locked error'));
                            }
                        }
                    }
                }
            }

            function filterCountryNames() {
                accountCtrl.countryNames = Util.getCountryAutocompleteOptions().filter(function (country) {
                    return accountCtrl.userAdress.country && country.toLowerCase().indexOf(accountCtrl.userAdress.country.toLowerCase()) !== -1;
                });
            }

            function openAutocompleteAddress(evt) {
                evt.preventDefault();
                return mDesign.dialog({
                    templateUrl: 'views/templates/choose-address.html',
                    controller: ['$scope', function ($dialogScope) {
                        var dialogCtrl = this;
                        Util.getAddressByZipCode(accountCtrl.userAdress.zipCode).then(function (result) {
                            dialogCtrl.addresses = result;
                            dialogCtrl.errorMessage = !result || !result.length;
                        })
                        $dialogScope.continue = function () {
                            if (dialogCtrl.addresses && ((dialogCtrl.addresses.length && !dialogCtrl.address) || dialogCtrl.errorMessage)) {
                                return;
                            }

                            delete dialogCtrl.address.description;
                            accountCtrl.userAdress = Object.assign(accountCtrl.userAdress, dialogCtrl.address);
                            _checkAddressFields();
                            mDesign.hide();
                        };
                        $dialogScope.cancel = function () {
                            mDesign.hide();
                        };
                    }],
                    controllerAs: 'dialogCtrl',
                    styleClass: 'choose-address',
                    ariaLabelledby: 'choose_address_dialog_title',
                })
            }

            // TODO move to service file
            //#region new address
            function saveMembershipInfoV2() {
                var phonesCopy = angular.copy(accountCtrl.userSettings.phones);
                if (accountCtrl.customPhoneValidation) {
                    accountCtrl.editPhonesMode = {
                        1: !accountCtrl.userSettings.phones[1].phoneNumber,
                        2: !accountCtrl.userSettings.phones[2].phoneNumber,
                        3: !accountCtrl.userSettings.phones[3].phoneNumber,
                    }
                    accountCtrl.homePhone = phonesCopy[1] ? phonesCopy[1].customPhoneNumber : '';
                    accountCtrl.workPhone = phonesCopy[2] ? phonesCopy[2].customPhoneNumber : '';
                    accountCtrl.mobilePhone = phonesCopy[3] ? phonesCopy[3].customPhoneNumber : '';
                    var phoneCopyArr = Object.values(phonesCopy) || [];

                    phoneCopyArr.forEach(function (phone) {
                        if (accountCtrl.userSettings.phones && accountCtrl.userSettings.phones[phone.typeVal] && (accountCtrl.userSettings.phones[phone.typeVal].phoneNumber || accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber)) {
                            accountCtrl.userSettings.phones[phone.typeVal].phoneNumber = accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber ? accountCtrl.userSettings.phones[phone.typeVal].areaCode + accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber : '';
                            accountCtrl.userSettings.phones[phone.typeVal].customValidated = (accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber && accountCtrl.customPhoneValidation);
                            compileCustomValidatedPhone(accountCtrl.userSettings.phones[phone.typeVal]);
                        }
                        _setPhoneInputs(phone.typeVal);
                    });
                    accountCtrl.userSettings.phones = phones;
                }

                if (accountCtrl.userSettings.password !== accountCtrl.userSettings.confirmPassword) {
                    return mDesign.alert('The passwords must match');
                }

                var sendingData = {
                    firstName: accountCtrl.userSettings.firstName,
                    lastName: accountCtrl.userSettings.lastName,
                    birthDate: accountCtrl.userSettings.dateOfBirth,
                    allowSendPromotions: accountCtrl.userSettings.allowSendPromotions,
                    allowSendSmsPromotions: accountCtrl.userSettings.allowSendSmsPromotions,
                    allowSendEmailPromotions: accountCtrl.userSettings.allowSendEmailPromotions,
                    gender: parseFloat(accountCtrl.userSettings.gender),
                    phones: accountCtrl.userSettings.phones,
                };

                if (accountCtrl.userSettings.password) {
                    sendingData.password = accountCtrl.userSettings.password;
                }

                // can only unselect is senior citizen through here
                if (!accountCtrl.isSeniorCitizen && accountCtrl.user.isSeniorCitizen) {
                    sendingData.isSeniorCitizen = false;
                }
                accountCtrl.phoneValidationSubmitted = true;
                Api.request({
                    method: 'PATCH',
                    url: 'retailers/:rid/users/:uid',
                    data: sendingData
                }).then(function () {
                    _successMsg();
                }).catch(function () {
                    User.getUserSettings(true).then(function (userSettings) {
                        accountCtrl.user = userSettings;
                        angular.forEach(userSettings.phones, function (phone) {
                            _setPhoneInputs(phone.typeVal);
                            accountCtrl.editPhonesMode[phone.typeVal] = false;
                            compileCustomValidatedPhone(phone);
                        });
                    });
                });
            }

            function saveAddress() {
                $q.resolve(_validateAddressFields()).then(function (emptyFieldError) {
                    if (!!emptyFieldError) {
                        if (emptyFieldError && emptyFieldError.selector && emptyFieldError.selector[0]) {
                            var checkoutContainer = document.querySelector('#main');
                            if (checkoutContainer && emptyFieldError.selector[0]) {
                                angular.element(checkoutContainer).scrollTop(emptyFieldError.selector[0].offsetTop, 100);
                                emptyFieldError.selector.focus();
                            }
                        }

                        return emptyFieldError;
                    }

                    var clonedUserAddress = angular.copy(accountCtrl.userAdress)
                    if(accountCtrl.isDropPinAddressNotDetected && AddressFormService.isGoogleMapDropPinValidateHouseNumAndStreet) {
                        clonedUserAddress.text1 = null;
                    }

                    var _userAddress = AddressFormService.getCheckoutAddress(clonedUserAddress);
                    Api.request({
                        method: 'PATCH',
                        url: 'retailers/:rid/users/:uid',
                        data: {
                            addresses: [_userAddress]
                        }
                    }).then(function () {
                        $window.localStorage.removeItem("mobileZuzTypedAreaText");
                        $window.localStorage.removeItem("mobileZuzTypedAddressText");
                        $window.localStorage.removeItem("newAddress");
                        _originUserAddress = angular.copy(_userAddress);
                        _successMsg();
                    }).catch(function () {
                        User.getUserSettings(true).then(function (userSettings) {
                            accountCtrl.user = userSettings;
                        });
                    });
                })
            }

            function _validateAddressFields() {
                var checkoutForm = document.querySelector('#adress-form');

                // validate base on address form settings
                var element = getInvalidFormElement();
                if (element) {
                    return { selector: angular.element(checkoutForm.querySelector(element)) };
                }

                if (accountCtrl.isAddressVerificationEnabled) {
                    var suggestionFieldsIsValid = _verifyIsSuggestedValue();

                    for (var key in suggestionFieldsIsValid) {
                        if (!suggestionFieldsIsValid[key]) {
                            accountCtrl.userAdress[key] = '';
                            return AddressFormService.showAddressWarning(key).then(function () {
                                var _selector = AddressFormService.addressFormElementIds[key];
                                if (key === 'text1') { _selector = AddressFormService.addressFormElementIds.address };
                                return { selector: angular.element(checkoutForm.querySelector(_selector)) };
                            });
                        }
                    }
                }

                return $q.resolve(_validateText1HouseNumber());
            }

            function _validateText1HouseNumber() {
                var isIgnoreValidation = [
                    _wasText1HouseNumberShown,
                    !accountCtrl.userAdress.text1,
                    accountCtrl.userAdress.houseNumber,
                    !accountCtrl.streetIsRequire,
                    accountCtrl.userAdress.externalPlaceId,
                    accountCtrl.userAdress.lat && accountCtrl.userAdress.lng,
                ].some(function (value) {
                    return value;
                });

                if (isIgnoreValidation) {
                    return;
                }

                var _text1 = accountCtrl.userAdress.text1;
                var splitAddress = _text1.replace(/,/g, ' ');
                splitAddress = splitAddress.replace(/\s+/g, ' ');
                splitAddress = splitAddress.split(' ');

                var hasHouseNumber = splitAddress.length >= 2 && splitAddress.some(function (word) {
                    return _houseNumberRegExp.test(word);
                });
                if (hasHouseNumber) {
                    return;
                }

                _wasText1HouseNumberShown = true;
                return mDesign.dialog({
                    focusOnOpen: false,
                    clickOutsideToClose: true,
                    templateUrl: 'views/templates/address-number-warning.html',
                    controller: ['$scope', function ($scope) {
                        $scope.hide = mDesign.hide;
                    }]
                }).then(function () {
                    return { selector: angular.element(document.querySelector(AddressFormService.addressFormElementIds.address)) };
                });
            }


            function getInvalidFormElement() {
                var addressData = accountCtrl.userAdress;
                var isDropPinAddress = accountCtrl.isDropPinAddress;
                var isDropPinAddressNotDetected = accountCtrl.isDropPinAddressNotDetected;

                return AddressFormService.getInvalidFormElement(addressData, isDropPinAddress, isDropPinAddressNotDetected);
            }

            function onCityBlurV2(event) {
                if(_isClickToSuggestion(event)) return;

                var _isCityChanged = _isLocationChanged('city');
                if (accountCtrl.isAddressVerificationEnabled && accountCtrl.isAddressFilteringCityMode && _isCityChanged) {
                    accountCtrl.suggestedAddresses = [];
                    accountCtrl.userAdress.text1 = '';
                    accountCtrl.userAdress.street = '';
                    accountCtrl.userAdress.houseNumber = '';
                    accountCtrl.userAdress.zipCode = '';
                }

                _handleOnLocationBlur('city');
            }

            function onAddressBlurV2(event, fieldName) {
                if(_isClickToSuggestion(event)) return;

				var validatedResult = AddressFormService.onAddressBlur(fieldName, accountCtrl.backupAddress, accountCtrl.userAdress, accountCtrl.suggestedAddresses);
				if (validatedResult && validatedResult.isValid && validatedResult.suggestion) {
                    onAddressChosenV2({ option: validatedResult.suggestion }, fieldName);
				}

                _handleOnLocationBlur(fieldName);
            }

            function onHouseNumberBlurV2() {
                var fieldName = 'houseNumber';

                var _isAddressChanged = _isLocationChanged(fieldName);
                if (_isAddressChanged) {
                    AddressFormService.cleanAddressDataBaseOnRetailerConfig(accountCtrl.userAdress);
                }
            }

            function isExistedInSuggestions(addressType, value, suggestions) {
                return AddressFormService.isExistedInSuggestions(accountCtrl.userAdress, addressType, value, suggestions);
            }

            function _isLocationChanged(field) {
                return AddressFormService.isLocationChanged(field, accountCtrl.backupAddress, accountCtrl.userAdress);
            }

            function _handleOnLocationBlur(emittedField) {
                AddressFormService.handleOnLocationBlur(emittedField, accountCtrl.backupAddress, accountCtrl.userAdress, _originUserAddress);
            }


            function getCityAutoCompleteOptionsV2() {
                var city = extractAddressField('city');
                if (!city) {
                    return $q.resolve([]);
                }

                return AddressService.getCitiesFromGoogleMapApi(city).then(function (data) {
                    accountCtrl.suggestedCities = data.cities;
                    return data.cities;
                });
            }

            function onCityChosenV2($event) {
                var cityComponent = $event && $event.option && $event.option.component;

                if ($event.option.placeId) {
                    cityComponent.placeId = $event.option.placeId;
                }

                if (cityComponent) {
                    angular.extend(accountCtrl.userAdress, cityComponent);
                }
                
                onCityBlurV2();
                return;
            }

            function onAddressInputKeydownV2() {
                if (accountCtrl.isAddressVerificationEnabled) {
                    accountCtrl.isRunAddressAutoComplete = true;
                }
            }

            function getAddressAutoCompleteOptionsV2(fieldName, isForce) {
                if (!accountCtrl.isRunAddressAutoComplete && !isForce) {
                    return $q.resolve([]);
                }

                var addressQuery = extractAddressField(fieldName);
                var _addressFilteringMode = AddressFormService.isUseNewAddressesFeature && accountCtrl.enableAddressFiltering && AddressFormService.addressFiltering ? AddressFormService.addressFiltering : null;

                // Call google api
                return AddressService.getAddressAutoCompleteOptions(addressQuery, {
                    addressFilteringMode: _addressFilteringMode,
                    placeId: accountCtrl.userAdress.placeId,
                    city: accountCtrl.userAdress.city,
                    zipCode: accountCtrl.userAdress.zipCode,
                    languageId: $rootScope.config.language.id
                }).then(function (addresses) {
                    accountCtrl.suggestedAddresses = addresses;
                    return addresses;
                });
            }

            function goToGoogleMapSelectPage(_defaultLocation) {
                $state.go("app.cart.checkout.process.map", { from: STATE_NAME, defaultLocation: _defaultLocation });
            }

            function openGoogleMapDialogV2() {
                var _defaultLocation = AddressFormService.getDefaultLocation(accountCtrl.userAdress);

                if (window.cordova) {
                    return goToGoogleMapSelectPage(_defaultLocation);
                }

                mDesign.dialog({
                    clickOutsideToClose: true,
                    templateUrl: 'views/templates/google-map-dialog.html',
                    controller: 'GoogleMapDialogCtrl as googleMapDialogCtrl',
                    locals: {
                        defaultLocation: _defaultLocation
                    }
                }).then(function (selectedAddress) {
                    _handleSelectedGoogleMapAddress(selectedAddress);
                });
            }

            function _handleSelectedGoogleMapAddress(selectedAddress) {
                if (!selectedAddress) {
                    return;
                }

                _disableAllDropPinFields();
                accountCtrl.isDropPinAddress = true;
                accountCtrl.isDropPinAddressNotDetected = !selectedAddress.hasHouseNumberAndRoute;
                var _address = AddressFormService.onDroppedPinAddress(selectedAddress);

                angular.extend(accountCtrl.userAdress, _address);
                angular.extend(accountCtrl.backupAddress, accountCtrl.userAdress);

                // set form value change to show save btn
                _triggerFormValueChange();

                if (selectedAddress.zipCode) {
                    onZipCodeBlur();
                }
            }

            function onAddressChosenV2($event, fieldName) {
                var addressComponent = $event && $event.option && $event.option.component;
                if (addressComponent) {
                    return AddressFormService.onAddressChosen(addressComponent.externalPlaceId, $rootScope.config.language.id).then(function (address) {
                        angular.extend(accountCtrl.userAdress, address);
                        accountCtrl.isRunAddressAutoComplete = false;
                        angular.extend(accountCtrl.backupAddress, accountCtrl.userAdress);
                    }).finally(function () {
                        // set form value change to show save btn
                        _triggerFormValueChange();
                        getAddressAutoCompleteOptionsV2(fieldName, true);
                        onAddressBlurV2(null, fieldName);
                    });
                }
            }

            function extractAddressField(field) {
                return AddressFormService.extractAddressField(field, accountCtrl.userAdress);
            }

            function isDisableAddressFieldV2(filteringMode) {
                return AddressFormService.isDisableAddressField(filteringMode, accountCtrl.userAdress);
            }

            function isDropPinRequiredStreetAndHouseNumber() {
                return AddressFormService.isDropPinRequiredStreetAndHouseNumber(accountCtrl.isDropPinAddress, accountCtrl.isDropPinAddressNotDetected);
            }

            function editDropPinAddressField(elementSelector, field) {
                var _element = document.querySelector(elementSelector);
                if (_element) {
                    accountCtrl.dropPinDisableFields[field] = false;
                    $timeout(function () {
                        _element.focus();
                    }, 0);
                }
            }

            function isShowAddressField(fieldName) {
                return AddressFormService.isShowAddressField(fieldName, accountCtrl.isDropPinAddress, accountCtrl.isDropPinAddressNotDetected);
            }

            function _getZipCodeFromGoogleMapApi(zipCode) {
                return AddressService.getZipCodeFromGoogleMapApi(zipCode, '', zipCode, true);
            }

            function onZipCodeBlur() {
                if (!accountCtrl.isAddressFilteringZipCodeMode) {
                    return
                }

                var _isZipCodeChanged = _isLocationChanged('zipCode');
                if (accountCtrl.isAddressVerificationEnabled && _isZipCodeChanged) {
                    accountCtrl.suggestedAddresses = [];
                    accountCtrl.suggestedCities = [];
                    accountCtrl.userAdress.text1 = '';
                    accountCtrl.userAdress.city = '';
                }

                _handleOnLocationBlur('zipCode');

                if (accountCtrl.isAddressVerificationEnabled) {
                    var zipCode = extractAddressField('zipCode');
                    if (!zipCode) {
                        return $q.resolve([]);
                    }

                    //generate another promise that will return the full cities array (no only names)
                    var zipCodesDefer = $q.defer();
                    var getRequestFunc = _getZipCodeFromGoogleMapApi;

                    return getRequestFunc(zipCode).then(function (data) {
                        accountCtrl.suggestedZipCodes = data.zipCodes;
                        var isExisted = isExistedInSuggestions(_ADDRESS_TYPE_MAP.zipCode, zipCode, accountCtrl.suggestedZipCodes);
                        accountCtrl.isZipCodeValid = isExisted && !!accountCtrl.suggestedZipCodes.length;

                        zipCodesDefer.resolve(data.zipCodes);
                        return data.zipCodes;
                    }).catch(function (err) {
                        zipCodesDefer.reject(err);
                    });
                }
            }

            function _verifyIsSuggestedValue() {
                return AddressFormService.verifyIsSuggestedValue(
                    accountCtrl.userAdress, 
                    accountCtrl.isDropPinAddress, 
                    accountCtrl.suggestedAddresses, 
                    accountCtrl.suggestedCities, 
                    accountCtrl.suggestedZipCodes
                );
            }

            function cancelPinnedAddress() {
                accountCtrl.isDropPinAddress = false;
                accountCtrl.isDropPinAddressNotDetected = false;
                AddressFormService.cancelPinnedAddress(accountCtrl.userAdress)
            }

            function _triggerFormValueChange() {
                // set form value change to show save btn
                accountCtrl.userAdressForm.$setDirty();
            }

            function _isClickToSuggestion(event){
                // if click to choose suggestion, disable blur event temporarily
                var _parentTargetClickId = event && event.relatedTarget && event.relatedTarget.parentElement ? event.relatedTarget.parentElement.id : null;
                if (_parentTargetClickId && _parentTargetClickId.startsWith('sp_autocomplete_')) {
                    return true;
                }
                return false;
            }

            function setUserAdressFormRef(userAdressFormRef) {
                accountCtrl.userAdressForm = userAdressFormRef;
            }

            function _getAddressFromMap() {
                setTimeout(function () {
                    var adrsDetailsParams = $state.params.addressDetails;
                    if (adrsDetailsParams) {
                        // set form data after droppin
                        _handleSelectedGoogleMapAddress(JSON.parse(adrsDetailsParams));

                        // trigger open address tab
                        var _addressView = document.getElementById('addresses')
                        _addressView.click();
                        _addressView.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 100);
            }

            function getAddressFieldLabel(fieldName, options) {
                return AddressFormService.getAddressFieldLabel(fieldName, $rootScope.config.language.id, options);
            }

            function getAddressFormFieldSettings(fieldName) {                    
                return AddressFormService.getAddressFormFieldSettings(fieldName);
            }

            function _disableAllDropPinFields() {
                AddressFormService.disableAllDropPinFields(accountCtrl.dropPinDisableFields);
            }

            function getDropPinClarifyMessage() {
                return AddressFormService.getDropPinClarifyMessage($rootScope.config.language.culture);
            }
            //#endregion new address

            Util.destroyListeners($scope, _listeners);
        }]);
})(angular);
